import { apiClient } from '../config/api';

export interface RepasseDocumentoResumo {
  id: string;
  numeroDocumento?: string;
  codigoProposta?: string;
  numeroApolice?: string;
  dataEmissao?: string;
  inicioVigencia?: string;
  fimVigencia?: string;
  premioLiquido?: number;
  comissao?: number;
  percentualComissao?: number;
  cliente?: {
    id: string;
    nome: string;
    cpfCnpj: string;
  };
  seguradora?: {
    id: string;
    nome: string;
  };
  produto?: {
    id: string;
    nome: string;
  };
  resumoRepasses?: {
    total: number;
    quantidade: number;
    diferenca: number;
    percentualRepassado: number;
  };
}

export interface RepasseDocumentoListResponse {
  data: RepasseDocumentoResumo[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface RepasseDetalhe {
  id: string;
  cliente: string;
  dataPagamento: string;
  repassePago: string;
  parcela: string;
}

export interface DocumentoRepasseDetalhe {
  documento: {
    id: string;
    numeroDocumento?: string;
    codigoProposta?: string;
    numeroApolice?: string;
    inicioVigencia?: string;
    fimVigencia?: string;
    premioLiquido?: number;
    comissao?: number;
    percentualComissao?: number;
    cliente?: {
      id: string;
      nome: string;
      cpfCnpj: string;
    };
    seguradora?: {
      id: string;
      nome: string;
      taxaComissao?: number;
      custoAdministrativo?: number;
    };
    produto?: {
      id: string;
      nome: string;
    };
  };
  repasses: {
    total: number;
    quantidade: number;
    lista: RepasseDetalhe[];
  };
  resumo: {
    comissaoDocumento: number;
    totalRepasses: number;
    diferenca: number;
    percentualRepassado: number;
  };
}

export const repasseDocumentoService = {
  async getResumoRepasses(params: {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    search?: string;
    seguradoraId?: string;
    produtoId?: string;
    dataInicio?: string;
    dataFim?: string;
  } = {}): Promise<RepasseDocumentoListResponse> {
    const qp = new URLSearchParams();
    if (params.page) qp.set('page', String(params.page));
    if (params.limit) qp.set('limit', String(params.limit));
    if (params.sortBy) qp.set('sortBy', params.sortBy);
    if (params.sortOrder) qp.set('sortOrder', params.sortOrder);
    if (params.search) qp.set('search', params.search);
    if (params.seguradoraId) qp.set('seguradoraId', params.seguradoraId);
    if (params.produtoId) qp.set('produtoId', params.produtoId);
    if (params.dataInicio) qp.set('dataInicio', params.dataInicio);
    if (params.dataFim) qp.set('dataFim', params.dataFim);

    const res = await apiClient.request<any>(`/documentos/resumo-repasses?${qp.toString()}`);
    
    return {
      data: res.data || [],
      pagination: res.pagination || { page: 1, limit: 20, total: 0, totalPages: 0 }
    };
  },

  async getRepassesPorDocumento(documentoId: string): Promise<DocumentoRepasseDetalhe> {
    const res = await apiClient.request<any>(`/documentos/${documentoId}/repasses/resumo`);
    return res.data || res;
  }
};
